import { spacer40, spacer48 } from '@spotify-internal/encore-web/core';
import { AnimatePresence, m } from 'framer-motion';
import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useActiveSubmenuContext } from '../../../../ActiveSubmenu/ActiveSubmenuProvider';
import { useSubmenuItem } from '../../../../ActiveSubmenu/useSubmenuItem';
import { NavBarHeightSmScreen } from '../../../constants';
import { HomeMenu } from './Menus/HomeMenu';
import { SubMenu } from './Menus/SubMenu';
import { containerVariants, homeMenuVariants, subMenuVariants } from './config';
const StyledFlyout = styled(m.div).attrs({
    className: 'encore-inverted-dark-set',
}) `
  background-color: var(--background-base);
  bottom: 0;
  display: flex;
  position: fixed;
  z-index: 6;
  inset-inline-end: 0;
  width: 100%;
  top: 0;
  overflow-y: auto;
`;
const Layout = styled(m.div) `
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-top: calc(${NavBarHeightSmScreen}px + ${spacer40});
  padding-bottom: ${spacer48};
`;
export const FlyoutMenu = ({ open, dir, userState, onNavigate = () => { }, }) => {
    const { activeSubmenu } = useActiveSubmenuContext();
    const activeSubmenuItem = useSubmenuItem(activeSubmenu);
    const contentKey = activeSubmenu ? activeSubmenu : 'home';
    useEffect(() => {
        if (open) {
            document.body.style.overflow = 'hidden';
        }
        else {
            document.body.style.overflow = '';
        }
        return () => {
            document.body.style.overflow = '';
        };
    }, [open]);
    return (React.createElement(StyledFlyout, { initial: "initial", animate: open ? 'open' : 'closed', exit: "closed", variants: containerVariants, dir: dir, role: "dialog", className: "encore-creator-light-theme encore-inverted-dark-set" },
        React.createElement(AnimatePresence, { mode: "popLayout" },
            React.createElement(Layout, { key: contentKey + new Date(), initial: "exit", animate: "animate", exit: "exit", variants: activeSubmenuItem ? subMenuVariants(open) : homeMenuVariants(open), "data-testid": contentKey }, !activeSubmenu ? (React.createElement(HomeMenu, { userState: userState, onNavigate: onNavigate, canAnimate: open })) : (React.createElement(SubMenu, { onNavigate: onNavigate, activeItem: activeSubmenuItem }))))));
};
//# sourceMappingURL=index.js.map